import "./App.css";
import "./styles/themes/variables.css";
import "./styles/dashboardTheme.css";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes";
import Layout from "./components/layout/Layout";
import { useSelector } from "react-redux";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useMemo, useEffect } from "react";
import { CONFIG } from "./config";

import { useAuth0 } from "@auth0/auth0-react";
import refreshData from "./functions/refreshData";
import handleThemeChange from "./functions/handleThemeChange";

function App() {
  const { user, getAccessTokenSilently } = useAuth0();
  const themeMode = useSelector((state) => state.themeMode);
  const theme = useMemo(
    () =>
      createTheme({
        breakpoints: {
          values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
            xxl: 2048,
          },
        },
        palette: {
          mode: themeMode === "dark" ? "dark" : "light",
          gradient:
            themeMode === "dark"
              ? "linear-gradient( to bottom, #1a1f1a 0%, #1a1f1a 550px, #232a23 550px, #232a23 150%)"
              : "linear-gradient( to bottom, " +
                CONFIG.primaryColour +
                " 0%, " +
                CONFIG.primaryColour +
                " 550px, #EFEFEF 550px , #EFEFEF 150%)",
          primary: {
            main: CONFIG.primaryColour,
          },
          secondary: {
            main: "#bdbdbd",
          },
          error: {
            main: "#fe3e26",
          },
          warning: {
            main: "#fedd37",
          },
          success: {
            main: "#26A69A",
          },
          info: {
            main: "#38adfe",
          },
          green: {
            main: "#26A69A",
          },
          yellow: {
            main: "#fedd37",
          },
          red: {
            main: "#fe3e26",
          },
          blue: {
            main: "#38adfe",
          },
          gray: {
            main: "#bdbdbd",
          },
        },
      }),
    [themeMode]
  );

  useEffect(() => {
    const themeFromLocal = localStorage.getItem("theme");
    handleThemeChange(themeFromLocal);
  }, [themeMode, theme]);

  useEffect(() => {
    if (!user) return;
    async function fetchToken() {
      try {
        const accessToken = await getAccessTokenSilently();
        localStorage.setItem("access_token", accessToken);
      } catch (e) {
        // Token refresh error - will retry on next interval
      }
    }

    async function fetchDataAndToken() {
      if (!user) return;

      await fetchToken();
      refreshData(user);
    }

    fetchDataAndToken();
  }, [user, getAccessTokenSilently]);

  useEffect(() => {
    if (!user) return;

    let refreshRate = Math.max(
      parseInt(localStorage.getItem("refreshRate")) || CONFIG.defaultRefreshRate,
      15
    );
    refreshRate = refreshRate * 1000;

    //interval
    let interval = setInterval(async () => {
      await refreshData(user);
    }, refreshRate);

    return () => clearInterval(interval);
  }, [user]);

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <Layout>
          <AppRoutes />
        </Layout>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
